module.exports = __webpack_public_path__ + "static/img/banner_back.cd66f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_back.png
// module id = wFA+
// module chunks = 128